export default __webpack_public_path__ + "static/media/trabalhe-quando-quiser.54a6f1ce.png";